import { Box, Link, Typography } from '@mui/material'
import { SxProps } from '@mui/system'

import RectangleButtonComponent from 'components/RectangleButton'

import Wind2 from '../../assets/images/Wind2.svg'
import { styles } from './EmptySubPageContent.styles'

export interface Props {
	buttonOnClick: () => void
	buttonText: string
	disabled?: boolean
	licenseNotice?: boolean
	subtitle: string
	sxOverrides?: SxProps
}

export default function EmptySubPageContent({
	subtitle,
	buttonText,
	disabled,
	licenseNotice,
	buttonOnClick,
	sxOverrides,
}: Props) {
	return (
		<Box
			sx={
				{
					...(styles.container as object),
					...(sxOverrides as object),
				} as SxProps
			}
		>
			<img src={Wind2 as unknown as string} />
			{licenseNotice ? (
				<Typography sx={styles.licenseText}>
					Creating custom games is only available for licensed users.
					Request a{' '}
					<Link
						href="https://go.slalom.com/brainstorm-support"
						sx={styles.licenseLink}
					>
						license
					</Link>
					.
				</Typography>
			) : (
				<Typography sx={styles.subtitle}>{subtitle}</Typography>
			)}
			<RectangleButtonComponent
				color="secondary"
				text={buttonText}
				onClick={buttonOnClick}
				sx={styles.button}
				disabled={disabled}
			/>
		</Box>
	)
}
